import { useState, useEffect, useCallback } from 'react';
import { getMyFullStats } from '../lib/userProgressQueries';
import { evaluateMilestones, getNextHints } from '../data/milestones';
import { BODY_SYSTEMS } from '../lib/userProgressQueries';

export function useUserProgress(userId) {
  const [stats,    setStats]    = useState(null);
  const [loading,  setLoading]  = useState(true);
  const [error,    setError]    = useState(null);

  const load = useCallback(async () => {
    if (!userId) { setLoading(false); return; }
    setLoading(true);
    setError(null);
    try {
      const s = await getMyFullStats(userId);
      setStats(s);
    } catch (e) {
      setError(e.message || 'Error al cargar tu progreso');
    } finally {
      setLoading(false);
    }
  }, [userId]);

  useEffect(() => { load(); }, [load]);

  const milestones     = stats ? evaluateMilestones(stats)    : [];
  const nextHints      = stats ? getNextHints(stats, 2)       : [];

  // top systems sorted by count, derived client-side
  const topSystems = (() => {
    if (!stats?.journey?.length) return [];
    const counts = {};
    stats.journey.forEach(p => {
      if (p.sistema) counts[p.sistema] = (counts[p.sistema] || 0) + 1;
    });
    return Object.entries(counts)
      .sort((a, b) => b[1] - a[1])
      .map(([id, count]) => ({
        id,
        count,
        label: BODY_SYSTEMS.find(s => s.id === id)?.label || id,
      }));
  })();

  return { stats, loading, error, milestones, nextHints, topSystems, refresh: load };
}
